import React, { ReactNode, useContext } from "react";

import styled from "@emotion/styled";
import { Container } from "@mantine/core";
import { CurrentUserContext } from "modules/login/CurrentUserContext";

import { Footer } from "./common";
import { HeaderScreen } from "./common/HeaderScreen";
import PrivateLayoutSubHeader from "./common/PrivateLayoutSubHeader";

const StyleFooterPositionWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 10;
`;
const ContentContainerWrapper = styled.div`
  max-width: 100%;
  flex: 1;
`;
const PrivateLayoutWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;

  padding-bottom: 208px;

  @media only screen and (max-width: ${props => props.theme.other.breakpoints.xl}) {
    padding-bottom: 248px;
  }
  @media only screen and (max-width: ${props => props.theme.other.breakpoints.md}) {
    padding-bottom: 360px;
  }
`;
const ContentContainer = styled(Container)`
  display: flex;
  max-width: 1366px;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  @media only screen and (max-width: 1440px) {
    max-width: 75%;
  }
`;
interface PrivateLayoutProps {
  children: ReactNode;
  beforeContainer?: ReactNode;
  showSubHeader?: boolean;
  accountName?: string | null;
  preview?: boolean;
  showEditAccountDetailsIcon?: boolean;
  description?: string;
  setShowUpdateAccountModal?: React.Dispatch<React.SetStateAction<boolean>>;
}
const PrivateLayout: React.FC<PrivateLayoutProps> = ({
  children,
  beforeContainer,
  showSubHeader = true,
  accountName = null,
  showEditAccountDetailsIcon = false,
  setShowUpdateAccountModal,
  preview,
  description
}) => {
  const { userDetails } = useContext(CurrentUserContext);

  return (
    <PrivateLayoutWrapper>
      <HeaderScreen
        user={{
          name: `${userDetails?.firstName} ${userDetails?.lastName?.charAt(0)}${userDetails?.lastName ? "." : ""}`,
          image: "",
          accountName: accountName ?? userDetails?.accountName
        }}
        preview={preview}
      />
      {showSubHeader && (
        <PrivateLayoutSubHeader
          accountName={accountName}
          showEditAccountDetailsIcon={showEditAccountDetailsIcon}
          setShowUpdateAccountModal={setShowUpdateAccountModal}
          description={description}
        />
      )}
      {beforeContainer}
      <ContentContainerWrapper>
        <ContentContainer>{children}</ContentContainer>
      </ContentContainerWrapper>
      <StyleFooterPositionWrapper>
        <Footer
          preview={preview}
          links={[
            { label: "How it works", link: "" },
            { label: "About Us", link: "" },
            { label: "Contact Us", link: "" }
          ]}
        />
      </StyleFooterPositionWrapper>
    </PrivateLayoutWrapper>
  );
};

export default PrivateLayout;
